import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Box,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import EmailIcon from '@mui/icons-material/Email';
import ArticleIcon from '@mui/icons-material/Article';
import SettingsIcon from '@mui/icons-material/Settings';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { useLanguageUrl } from '../../utils/languageUtils';

const AdminNavigation: React.FC = () => {
  const { t } = useTranslation('admin');
  const location = useLocation();
  const navigate = useNavigate();
  const getLanguageUrl = useLanguageUrl();

  const menuItems = [
    {
      key: 'dashboard',
      label: t('navigation.dashboard'),
      icon: <DashboardIcon />,
      path: getLanguageUrl('adminDashboard'),
      exact: true,
    },
    {
      key: 'userManagement',
      label: t('navigation.userManagement'),
      icon: <PeopleIcon />,
      path: getLanguageUrl('adminUserManagement'),
    },
    {
      key: 'emailQueue',
      label: t('navigation.emailQueue'),
      icon: <EmailIcon />,
      path: getLanguageUrl('adminEmailQueue'),
    },
    {
      key: 'publications',
      label: t('navigation.publications'),
      icon: <ArticleIcon />,
      path: getLanguageUrl('adminPublications'),
    },
    {
      key: 'settings',
      label: t('navigation.settings'),
      icon: <SettingsIcon />,
      path: getLanguageUrl('adminSettings'),
    },
    {
      key: 'reports',
      label: t('navigation.reports'),
      icon: <AssessmentIcon />,
      path: getLanguageUrl('adminReports'),
    },
  ];

  const isActive = (path: string, exact?: boolean) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" component="div">
          {t('backoffice.title')}
        </Typography>
      </Box>
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.key} disablePadding>
            <ListItemButton
              selected={isActive(item.path, item.exact)}
              onClick={() => navigate(item.path)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default AdminNavigation;
